export { default } from 'common/validations/reset-password';
